import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    component: () => import('@/layouts/Main'),
    children: [
      {
        path: '/',
        redirect: '/dashboard'
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/Dashboard')
      },
      {
        path: '/trip/:id',
        name: 'trip',
        component: () => import('@/views/Trip')
      },
      {
        path: '/reports',
        name: 'reports',
        component: () => import('@/views/Reports')
      },
      {
        path: '/settings',
        name: 'settings',
        component: () => import('@/views/Settings')
      }
    ]
  },
  {
    path: '',
    component: () => import('@/layouts/Auth'),
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('@/views/Login')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
